import React, { Component } from "react";
import { connect } from "react-redux";
import { getLocation, push } from "connected-react-router";
import { TrackedWebsitesTabs } from "../components/shared/TrackedWebsites";
import {
  getTrackedWebsites,
  //getTrackedWebsitesWithOverviews,
  changeSelectedWebsite,
  addTrackedWebsite
} from "../store/tracked_websites/operations";
import { fetchSubscriptionPlans } from "../store/sales/operations";
import {
  isGettingTrackedWebsites,
  //isFetchingTrackedWebsitesAndOverviews,
  trackedWebsites,
  isAddingTrackedWebsite,
  getSelectedWebsiteGuid,
  getTrackedWebsitesNumber,
  getFaviconsUrls
} from "../store/tracked_websites/selectors";
import { isAddingTrackedKeywords } from "../store/tracked_keywords/selectors";
import { getMaxTrackedWebsitesNo } from "../store/sales/selectors";

class TrackedWebsites extends Component {
  componentDidMount() {
    this.props.fetchSubscriptionPlans();
    //this.props.getTrackedWebsitesWithOverviews();
    this.props.getTrackedWebsites();
  }

  onTabChange = website_guid => {
    this.props.changeSelectedWebsite(website_guid);
  };

  render() {
    return (
      <TrackedWebsitesTabs
        //isLoading={this.props.isFetchingTrackedWebsitesAndOverviews}
        isLoading={this.props.isFetchingTrackedWebsites}
        trackedWebsites={this.props.trackedWebsites}
        tabContent={this.props.tabContent}
        activeTabKey={this.props.selectedWebsite}
        onTabChange={key => this.onTabChange(key)}
        showStatus={this.props.showStatus}
        showAddNewWebsite={this.props.trackedWebsitesNo < this.props.maxTrackedWebsitesNo}
        showDomains={this.props.showDomains}
        onAddTrackedWebsite={url => this.props.addTrackedWebsite(url)}
        isAddingTrackedWebsite={this.props.isAddingTrackedWebsite}
        isAddingTrackedKeywords={this.props.isAddingTrackedKeywords}
        faviconsUrls={this.props.faviconsUrls}
        push={this.props.push}
        destroyInactiveTabs={this.props.destroyInactiveTabs}
      />
    );
  }
}

const mapStateToProps = state => ({
  isFetchingTrackedWebsites: isGettingTrackedWebsites(state),
  //isFetchingTrackedWebsitesAndOverviews: isFetchingTrackedWebsitesAndOverviews(state),
  isAddingTrackedWebsite: isAddingTrackedWebsite(state),
  isAddingTrackedKeywords: isAddingTrackedKeywords(state),
  trackedWebsites: trackedWebsites(state),
  selectedWebsite: getSelectedWebsiteGuid(state),
  maxTrackedWebsitesNo: getMaxTrackedWebsitesNo(state),
  trackedWebsitesNo: getTrackedWebsitesNumber(state),
  faviconsUrls: getFaviconsUrls(state),
  currentPath: getLocation(state).pathname
});

export default connect(mapStateToProps, {
  getTrackedWebsites,
  //getTrackedWebsitesWithOverviews,
  changeSelectedWebsite,
  addTrackedWebsite,
  fetchSubscriptionPlans,
  push
})(TrackedWebsites);
